import { FC, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "../Form";
import { roleSelector, userSelector } from "../../redux/selectors";
import { roleQuestions } from "../../utils/constants";
import { setRole } from "../../redux/actions/role";

const Role: FC<any> = (props) => {
  const { validateForm } = props;
  const { role } = useSelector(roleSelector);
  const { user } = useSelector(userSelector);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const handleChange = (formData: any, isValid: boolean) => {
    dispatch(
      setRole({
        ...role,
        formData: { ...role.formData, ...formData, userId: user.id },
        isConfigured: isValid,
      })
    );
  };

  useEffect(() => {
    if (!role.isConfigured && validateForm) {
      setError("You need to select atleast one preference from each section");
    } else {
      setError("");
    }
  }, [role.isConfigured, validateForm]);

  return (
    <>
      <Form
        id="role"
        questions={roleQuestions}
        handleChange={handleChange}
        formData={role.formData}
      />
      <p className="form-error-message">{error}</p>
    </>
  );
};

export default Role;
